import silverBrewLogo from '../images/SilverBrewGraphic.svg';

document.addEventListener("DOMContentLoaded", function (event) {

    document.querySelectorAll('[data-logo]').forEach((img) => {
        img.src = silverBrewLogo;
    });

    const loginSection = document.querySelector('[data-login]');
    if (loginSection) {
        const panels = loginSection.querySelectorAll('[data-login-panel]');
        const verifyModal = document.querySelector('[data-verify-modal]');

        const showPanel = (name) => {
            panels.forEach((panel) => {
                panel.hidden = panel.dataset.loginPanel !== name;
            });
        };

        const openVerifyModal = () => {
            if (!verifyModal) return;
            verifyModal.hidden = false;
            document.body.classList.add('body--modal-open');
        };

        const closeVerifyModal = () => {
            if (verifyModal) {
                verifyModal.hidden = true;
                document.body.classList.remove('body--modal-open');
            }
            if (window.location.hash === '#verify') {
                history.replaceState(null, '', window.location.pathname + window.location.search);
            }
        };

        const applyHash = () => {
            const hash = window.location.hash;
            if (hash === '#verify') {
                showPanel('login');
                openVerifyModal();
            } else if (hash === '#register') {
                showPanel('register');
                closeVerifyModal();
            } else {
                showPanel('login');
                closeVerifyModal();
            }
        };

        applyHash();
        window.addEventListener('hashchange', applyHash);
    }
});
